export type AutoplayControls = {
  start: () => void;
  stop: () => void;
};

export function scheduleDelayedAutoplay({
  autoplay,
  canStart,
  isAutoplayUsable = () => true,
  startDelayMs,
}: {
  autoplay: AutoplayControls;
  canStart: boolean;
  /** Guard against calling autoplay after Swiper destroy/remount. */
  isAutoplayUsable?: () => boolean;
  startDelayMs: number;
}): () => void {
  if (isAutoplayUsable()) {
    autoplay.stop();
  }

  if (!canStart) {
    return () => {};
  }

  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  if (startDelayMs > 0) {
    timeoutId = setTimeout(() => {
      if (!isAutoplayUsable()) {
        return;
      }
      autoplay.start();
    }, startDelayMs);
  } else if (isAutoplayUsable()) {
    autoplay.start();
  }

  return () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (isAutoplayUsable()) {
      autoplay.stop();
    }
  };
}
